import ld from 'lodash';
let _ = ld.noConflict();

import { useCreateParams } from './data.js';

export const useEmbedData = {
	show: false,
	width: '100%',
	height: '500',
	postsPerPage: 10,
	postType: '',
	url: '',
	code: '',
	copied: false,
};

/**
 * Open embed
 * @param {string} postType Post type of the embed
 */
export function useOpenEmbed(postType) {
	this.useEmbedData.postType = postType;
	this.useCreateEmbed();
	this.useEmbedData.show = true;
}

/**
 * Close embed
 */
export function useCloseEmbed() {
	this.useEmbedData.copied = false;

	this.useEmbedData.show = false;
}

/**
 * Create embed
 */
export function useCreateEmbed() {
	const urlLang = this.lang === 'fi' ? '' : `${this.lang}/`;

	if (Number.isNaN(Number(this.useEmbedData.postsPerPage))) {
		this.useEmbedData.postsPerPage = 10;
	} else if (this.useEmbedData.postsPerPage < 1) {
		this.useEmbedData.postsPerPage = 1;
	} else if (this.useEmbedData.postsPerPage > 20) {
		this.useEmbedData.postsPerPage = 20;
	}

	const postType = this.useEmbedData.postType;

	const queryObject = _.cloneDeep(this.useQuery);

	queryObject.postType = postType;
	queryObject.postsPerPage = this.useEmbedData.postsPerPage;

	const base = `${window.location.protocol}//${window.location.host}/${urlLang}embeds`;
	const url = useCreateParams(postType, queryObject, base, false, true);

	this.useEmbedData.url = url;
	this.useEmbedData.code = `<iframe height="${this.useEmbedData.height}" width="${this.useEmbedData.width}" src="${this.useEmbedData.url}"></iframe>`;
}

/**
 * Copy embed code to clipboard
 */
export function useCopyEmbed() {
	navigator.clipboard.writeText(this.useEmbedData.code);

	this.useEmbedData.copied = true;
}
